/**
 * SuggestionButtons - Accept/reject buttons for note suggestions
 */
import { uiLogger } from '@annote/core/utils/debug';
import styled from 'styled-components';
import { Note } from '@annote/types';
import { useSuggestedContext } from 'src/context/SuggestedContext';
import { colors } from '@annote/core/styles';
import { Check, X } from 'lucide-react';
import { CardButton } from './CardButton';

const SuggestionButtonsWrapper = styled.span`
  .accept button {
    background-color: ${colors.button.accept.primary};
    border-radius: 0 4px 4px 0;
    margin-left: 2px;
  }

  .accept:hover button {
    background-color: ${colors.button.accept.hover};
  }

  .reject button {
    background-color: ${colors.button.reject.primary};
    border-radius: 4px 0 0 4px;
  }

  .reject:hover button {
    background-color: ${colors.button.reject.hover};
  }
`;

export const SuggestionButtons: React.FC<{ note: Note }> = ({ note }) => {
  const { acceptSuggestion, rejectSuggestion } = useSuggestedContext();

  const handleAccept = async (): Promise<void> => {
    if (!note.suggestionId) {
      uiLogger.error('Note has no suggestionId:', note.id);
      return;
    }
    await acceptSuggestion(note.suggestionId);
  };

  const handleReject = (): void => {
    if (!note.suggestionId) {
      uiLogger.error('Note has no suggestionId:', note.id);
      return;
    }
    rejectSuggestion(note.suggestionId);
  };

  return (
    <SuggestionButtonsWrapper>
      <CardButton className="reject" iconSVG={X} onClick={handleReject} />
      <CardButton className="accept" iconSVG={Check} onClick={handleAccept} />
    </SuggestionButtonsWrapper>
  );
};
